var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VOverlay',{attrs:{"value":_vm.navigating,"z-index":"1001"}},[_c('VProgressCircular',{attrs:{"indeterminate":"","color":"accent","size":"64"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }